import { memo } from 'react';
import { useFirestore } from '@client/hooks/utils.hooks';
import { upsertAct } from '@client/slices/entities/acts.reducer';
import { getActById } from '@client/selectors/entities/acts';
import { ProfileTypes } from '@sda/enums';
import { ReviewProfile } from './ReviewProfile';
import { ProfileSkeleton } from './ProfileSkeleton';

interface ActProps {
  readonly actId: string;
  readonly disableProfileClick?: boolean;
  readonly showId?: string;
}

export const Act = memo<ActProps>(({ actId, disableProfileClick, showId }) => {
  const [profile, isLoading] = useFirestore(
    (SDK) => SDK.Acts.get(actId),
    {
      key: actId,
      upserter: upsertAct,
      selector: getActById,
    },
  );

  if (!profile || isLoading) {
    return <ProfileSkeleton />;
  }

  return (
    <ReviewProfile
      selectedProfileId={actId}
      selectedProfileType={ProfileTypes.ACT}
      disableProfileClick={disableProfileClick}
      showId={showId}
      {...profile}
    />
  );
});
